export default "__VITE_ASSET__CxS0tcGU__"